<template>
  <div :class="defaultCollection ? 'koc-view koc-instructor-card-default-collection-container' : 'koc-view koc-instructor-card-container' ">
    <div class="koc-instructor-card-container-image">
      <div
        class="koc-instructor-card-container-image-thumbnail"
        :style="`background-image: url(${state.instructor.images.full})`"
      />
      <div
        v-if="!state.isMobile"
        class="koc-instructor-card-container-image-text koc-montserrat koc-title"
      >
        <div>{{ state.instructor.excerpt }}</div>
        <a :href="FormattingService.formatUrl(state.instructor)"><span class="koc-instructor-card-container-image-text-link">VIEW COURSES</span></a>
      </div>
    </div>
    <div class="koc-instructor-card-container-details">
      <div
        class="koc-instructor-card-container-details-name"
        v-html="state.name"
      />
      <div v-if="state.isMobile">
        <div>{{ state.instructor.excerpt }}</div>
        <a :href="FormattingService.formatUrl(state.instructor)"><span class="koc-instructor-card-container-image-text-link">VIEW COURSES</span></a>        
      </div>
    </div>
  </div>
</template>

<script src="./instructor-card.js"></script>
<style lang="scss" scoped src="./instructor-card.scss"></style>